import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import myBooksReducer from "./slices/mybooksSlice";
import favoriteReducer from "./slices/favoriteSlice";
import categoryReducer from "./slices/categorySlice";
import subCategoryReducer from "./slices/subCategorySlice";
import tagsReducer from "./slices/tagSlice";
import UiReducer from "./slices/UiSlice";
import { logRocketReduxMiddleware } from "@/app/lib/logrocket";

export const store = configureStore({
  reducer: {
    user: authReducer,
    mybooks: myBooksReducer,
    favorites: favoriteReducer,
    categories: categoryReducer,
    subCategories: subCategoryReducer,
    tags: tagsReducer,
    uiSlice: UiReducer,
    // Add more reducers here
  },
  // ✅ LogRocket must be the LAST middleware so it observes every action with
  // the resulting state (state/action sanitizers live in app/lib/logrocket.ts).
  // Returns a pass-through middleware on the server and when LogRocket is off.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(logRocketReduxMiddleware()),
});

// Types for TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
